module.exports = __webpack_public_path__ + "assets/76bcebbd342f023fd7b745ad7a01743c.ttf";